import React from "react";
import styles from "../../styles/evento-detalle.module.css";

export function Tabs({ tabs, active, onChange }) {
    return (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
            {tabs.map((t) => {
                const isActive = active === t.key;
                const cls = [
                    styles.btn,
                    isActive ? (t.alert ? styles.danger : styles.primary) : (t.alert ? styles.dangerGhost : styles.ghost),
                ].join(" ");

                return (
                    <button key={t.key} type="button" className={cls} onClick={() => onChange(t.key)}>
                        {t.label}
                        {t.alert && <span style={{ marginLeft: 6 }}>●</span>}
                    </button>
                );
            })}
        </div>
    );
}
